import Util from '@/helper/Utility.js';
import { config } from "@/config/bzbsconfig.js";
/**
 * Bzbs login
 * @export AuthLoginConfigModel
 * @export AuthLoginConfigBuilder
 * Device login
 * @export AuthDeviceLoginConfigBuilder
 * @export AuthDeviceLoginConfigModel
 */
//#region AuthLoginConfig
export function AuthLoginConfigModel () {
    this.username = null;
    this.password = null;
    this.uuid = null;
    this.deviceNotiEnable = null;
    this.clientVersion = null;
    this.deviceToken = null;

    this.getParams = function () {
        let params = {
            username: this.username,
            password: this.password,
            uuid: this.uuid,
            app_id: config.client_id,
            os: "web",
            platform: "web",
            mac_address: this.uuid,
            device_noti_enable: this.deviceNotiEnable,
            client_version: this.clientVersion,
            device_token: this.deviceToken,
        };

        return Util.cleanObjectEmptyStr(params);
    }
}
export function AuthLoginConfigBuilder () {
    this.authLoginConfigModel = new AuthLoginConfigModel();
    this.create = function () {
        return this.authLoginConfigModel;
    };

    this.setUsername = function (username) {
        this.authLoginConfigModel.username = username;
        return this;
    };
    this.setPassword = function (password) {
        this.authLoginConfigModel.password = password;
        return this;
    };
    this.setUUID = function (uuid) {
        this.authLoginConfigModel.uuid = uuid;
        return this;
    };
    this.setDeviceNotiEnable = function (enable) {
        this.authLoginConfigModel.deviceNotiEnable = enable;
        return this;
    };
    this.setClientVersion = function (version) {
        this.authLoginConfigModel.clientVersion = version;
        return this;
    };
    this.setDeviceToken = function (token) {
        this.authLoginConfigModel.deviceToken = token;
        return this;
    };
}
//#endregion AuthLoginConfig
//#region AuthDeviceLoginConfig
export function AuthDeviceLoginConfigBuilder () {
    this.authDeviceLoginConfigModel = new AuthDeviceLoginConfigModel();
    this.create = () => {
        return this.authDeviceLoginConfigModel;
    };
    this.setUUID = (uuid) => {
        this.authDeviceLoginConfigModel.uuid = uuid;
        return this;
    };
    this.genUUID = () => {
        this.authDeviceLoginConfigModel.uuid = Util.getUUID();
        return this;
    };

    this.setAppId = (appId) => {
        this.authDeviceLoginConfigModel.app_id = appId;
        return this;
    };
    this.setPlatform = (platform) => {
        this.authDeviceLoginConfigModel.platform = platform;
        return this;
    };
    this.setOS = (os) => {
        this.authDeviceLoginConfigModel.os = os;
        return this;
    };
    this.setClientVersion = (clientVersion) => {
        this.authDeviceLoginConfigModel.client_version = clientVersion;
        return this;
    };
    this.setCarrier = (carrier) => {
        this.authDeviceLoginConfigModel.carrier = carrier;
        return this;
    };
    this.setDeviceToken = (deviceToken) => {
        this.authDeviceLoginConfigModel.device_token = deviceToken;
        return this;
    };
    this.setDeviceNotiEnable = (deviceNotiEnable) => {
        this.authDeviceLoginConfigModel.device_noti_enable = deviceNotiEnable;
        return this;
    };
    this.setMacAddress = (macAddress) => {
        this.authDeviceLoginConfigModel.mac_address = macAddress;
        return this;
    };
    this.setTransferPoints = (transferPoints) => {
        this.authDeviceLoginConfigModel.transfer_points = transferPoints
        return this;
    };
    this.setExtra = (extra) => {
        this.authDeviceLoginConfigModel.extra = extra;
        return this;
    };
    this.setContactNumber = (contactNumber) => {
        this.authDeviceLoginConfigModel.contact_number = contactNumber;
        return this;
    };
    this.setAccessToken = (accessToken) => {
        this.authDeviceLoginConfigModel.access_token = accessToken;
        return this;
    };
    this.setInfo = (info) => {
        this.authDeviceLoginConfigModel.info = info;
        return this;
    };
    this.setOTP = (otp, refcode) => {
        this.authDeviceLoginConfigModel.otp = otp;
        this.authDeviceLoginConfigModel.refcode = refcode;
        return this;
    };
    this.setDeviceAccount = (deviceAccount) => {
        this.authDeviceLoginConfigModel.device_account = deviceAccount;
        return this;
    };
    this.setTermAndCondition = (termAndCondition) => {
        this.authDeviceLoginConfigModel.termandcondition = termAndCondition;
        return this;
    };
    this.setDataPrivacy = (dataPrivacy) => {
        this.authDeviceLoginConfigModel.dataprivacy = dataPrivacy;
        return this;
    };
    this.setMarketingMessage = (marketingMessage) => {
        this.authDeviceLoginConfigModel.marketingmessage = marketingMessage;
        return this;
    };
}
export function AuthDeviceLoginConfigModel (dict) {
    if (!dict) dict = {};
    this.uuid = dict.uuid || '';
    this.app_id = dict.app_id || '';
    this.platform = dict.platform || 'web';
    this.os = dict.os || 'web';
    this.client_version = dict.client_version || '';
    this.carrier = dict.carrier || '';
    this.device_token = dict.device_token || '';
    this.device_noti_enable = dict.device_noti_enable || '';
    this.mac_address = dict.mac_address || '';
    this.transfer_points = dict.transfer_points || '';
    this.extra = dict.extra || '';
    this.contact_number = dict.contact_number || '';
    this.access_token = dict.access_token || '';
    this.info = dict.info || '';
    this.otp = dict.otp || '';
    this.refcode = dict.refcode || '';
    this.device_account = dict.device_account || '';
    this.termandcondition = dict.termandcondition || '';
    this.dataprivacy = dict.dataprivacy || '';
    this.marketingmessage = dict.marketingmessage || '';

    this.getParams = function() {
        var params = {
            uuid: this.uuid,
            app_id: this.app_id,
            platform: this.platform,
            os: this.os,
            client_version: this.client_version,
            carrier: this.carrier,
            device_token: this.device_token,
            device_noti_enable: this.device_noti_enable,
            mac_address: this.mac_address,
            transfer_points: this.transfer_points,
            extra: this.extra,
            contact_number: this.contact_number,
            access_token: this.access_token,
            info: this.info,
            otp: this.otp,
            refcode: this.refcode,
            device_account: this.device_account,
            termandcondition: this.termandcondition,
            dataprivacy : this.dataprivacy ,
            marketingmessage: this.marketingmessage
        };
        params = Util.cleanObjectEmptyStr(params);
        return params;
    };
}
//#endregion AuthDeviceLoginConfig
